import { render } from "./GroupingControl.vue?vue&type=template&id=ef6fb41a"
import script from "./GroupingControl.vue?vue&type=script&lang=js"
export * from "./GroupingControl.vue?vue&type=script&lang=js"
script.render = render

export default script